<script>
    import gsap from 'gsap';
    import DrawSVGPlugin from 'gsap/DrawSVGPlugin';
    import {onMount, onDestroy} from "svelte";

    gsap.registerPlugin(DrawSVGPlugin);

    let displayNum = 0;

    function interpolate(start, target, durationMS) {
        if (start === target) {
            return;
        }

        const steps = target - start;
        const frameDuration = durationMS / steps;
        const newStart = start + 1;

        displayNum = newStart;

        setTimeout(() => interpolate(newStart, target, durationMS - frameDuration), frameDuration);
    }

    let drawLine;
    let tl = gsap.timeline();
    let svgElement;

    onMount(() => {
        tl.fromTo(drawLine, {
            drawSVG: "0% 0%",
            transformOrigin: 'center center',
        }, {
            drawSVG: "0% 100%",
            stagger: 0.15,
            duration: 1,
            onStart: () => {
                interpolate(0, 91, 1000)
            },
        });

        tl.play();
    });

    onDestroy(() => {
        tl.clear();
        tl = null;
    })
</script>

<svg xmlns="http://www.w3.org/2000/svg" width="100%" viewBox="0 0 380 678" bind:this={svgElement}>
    <defs>
        <clipPath id="clip-path">
            <rect id="Rectangle_762" data-name="Rectangle 762" width="195.569" height="201.63" fill="none"/>
        </clipPath>
    </defs>
    <rect id="Rectangle_869" data-name="Rectangle 869" width="380" height="678"/>
    <text id="Are_you_greenwashing_or_or_are_you_the_real_deal_" data-name="Are you greenwashing or or are
you the real deal?" transform="translate(40 51.446)" fill="#fcd0b1" font-size="24" font-family="Metric-Regular, Metric">
        <tspan x="0" y="0">Are you greenwashing or are</tspan>
        <tspan x="0" y="28">you the real deal?</tspan>
    </text>
    <text id="say_that_thought_leadership_helps_us_understand_a_supplier_s_values_"
          data-name="say that thought leadership “helps us understand a supplier’s values”"
          transform="translate(40 362)" fill="#fff" font-size="24" font-family="Metric-Regular, Metric">
        <tspan x="0" y="23">say that thought leadership</tspan>
        <tspan x="0" y="51">“helps us understand a</tspan>
        <tspan x="0" y="79">supplier’s values”</tspan>
    </text>
    <text id="_91_" data-name="91%" transform="translate(92 184)" fill="#fff" font-size="86"
          font-family="Metric-Bold, Metric" font-weight="700">
        <tspan x="31.085" y="81">{displayNum}%</tspan>
    </text>
    <g id="Group_1477" data-name="Group 1477" transform="translate(92 128)">
        <g id="Group_1477-2" data-name="Group 1477" clip-path="url(#clip-path)">
            <path bind:this={drawLine} id="Path_14763" data-name="Path 14763" d="M45.918,22.117A96.8,96.8,0,1,0,97.784,7.061" fill="none"
                  stroke="#008ed2" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"/>
            <path id="Path_14764" data-name="Path 14764" d="M92.541,6.6a5.4,5.4,0,1,1,5.4,5.4,5.4,5.4,0,0,1-5.4-5.4"
                  fill="#fff"/>
            <path id="Path_14765" data-name="Path 14765" d="M92.541,6.6a5.4,5.4,0,1,1,5.4,5.4A5.4,5.4,0,0,1,92.541,6.6Z"
                  fill="none" stroke="#100f0c" stroke-miterlimit="10" stroke-width="2.398"/>
        </g>
    </g>
</svg>
